export function computeVoiceEventId(notification: uui.domain.client.rm.OrderStepVoiceCall) {
  return `${notification.driverId}_${notification.startTs}`
}
